import styled from 'styled-components';

const StyledTimeLineCarousel = styled.div`
  position: relative;
  width: 100%;
  margin-top: 80px;

  .timeline--slider{
    position: relative;
    width: 100%;
    display: flex;
    align-item: center;
    justify-content: flex-start;
    transform: translateX(0);
    transition: transform .5s;
    overflow: visible;
    .swiper-slide{
      flex: 0 0 83%;
      width: 83%;
    }
  }
  
  @media screen and (max-width: 1439px){
   
  }
  @media screen and (max-width: 1023px){
    margin-top: 64px;
  }
  @media screen and (max-width: 767px){
    margin-top: 40px;
    
  }
`;

export {
  StyledTimeLineCarousel,
};

